import moment from 'moment'
import { localToUTC, localToCompanyOffsetStartOfDay, utcToLocalDate } from '@/utils/DateFormatter.js'

export const EUDR_FIRST_YEAR = 2020

// A selected calendar month → the UTC half-open [start, end) range the server filters on: end is the first
// instant of the NEXT month, so adjacent periods can never share a ticket. Intentionally range-shaped so the
// UI can later offer a multi-month span without touching the API or the server.
export function monthYearToRange (year, month) {
  const start = moment({ year, month: month - 1, date: 1 })
  const end = moment({ year, month: month - 1, date: 1 }).add(1, 'month')
  return {
    startDate: localToUTC(start.format('YYYY-MM-DD')),
    endDate: localToCompanyOffsetStartOfDay(end.format('YYYY-MM-DD'))
  }
}

export function eudrYearOptions (currentYear) {
  const years = []
  for (let y = EUDR_FIRST_YEAR; y <= currentYear; y++) years.push(y)
  return years
}

// Current year only offers months up to the current month; past years offer all 12.
export function eudrMonthOptions (year, currentYear, currentMonth) {
  const max = year === currentYear ? currentMonth : 12
  const items = []
  for (let m = 1; m <= max; m++) items.push({ value: m, text: moment().month(m - 1).format('MMMM') })
  return items
}

// The window end is exclusive (first instant of the next period); show the last included day. Subtracting a
// second first also renders legacy inclusive ends (23:59:59.999) correctly.
export function windowEndDisplay (endDate, dateFormat = 'MM/DD/YYYY') {
  return utcToLocalDate(moment.utc(endDate).subtract(1, 'second').format(), dateFormat)
}
